import {chatLastReplyLabel} from './chatAppearance';

export default function ChatReplySummary({message, onOpen}) {
    const lastReply = chatLastReplyLabel(message.last_reply_at);
    return <button type="button" className="chat-thread-link" onClick={onOpen}
        aria-label={`Open thread, ${message.reply_count} replies${message.unread_reply_count ? `, ${message.unread_reply_count} unread` : ''}${lastReply ? `, ${lastReply}` : ''}`}>
        <strong>{message.reply_count} {message.reply_count === 1 ? 'reply' : 'replies'}</strong>
        {message.unread_reply_count > 0 ? <span className="chat-thread-unread">{message.unread_reply_count} new</span> : null}
        {lastReply ? <time className="chat-thread-last-reply" dateTime={message.last_reply_at}>{lastReply}</time> : null}
    </button>;
}
